const GA_TRACKING_ID = "G-HW8GRHTJXM"; // تعيين معرف التتبع لمرة واحدة

export const initializeAnalytics = () => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("config", GA_TRACKING_ID, {
      page_path: window.location.pathname,
    });
  }
};

export const trackPageView = (path) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("config", GA_TRACKING_ID, {
      page_path: path,
    });
  }
};

export const trackEvent = (action, category, label, value) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value || 0, // تحديد قيمة افتراضية لمنع الأخطاء
    });
  }
};
